export class PromiseCacheItem {
    constructor() {
        this.isValueSet = false;
        this.isErrorSet = false;
    }
    cachePromise(promise) {
        this.promise = promise;
    }
    setResolved(value) {
        this.isValueSet = true;
        this.value = value;
    }
    setRejected(error) {
        this.isErrorSet = true;
        this.error = error;
    }
    accessCache() {
        if (this.isValueSet) {
            return Promise.resolve(this.value);
        }
        if (this.isErrorSet) {
            return Promise.reject(this.error);
        }
        return this.promise;
    }
    clearCachedPromise() {
        this.promise = undefined;
    }
    get isFulfilled() {
        return this.isValueSet;
    }
    get isRejected() {
        return this.isErrorSet;
    }
    get isPending() {
        return !this.isFulfilled && !this.isRejected;
    }
}
